import httpClient from '../../services/http-client';
import { API_SUB_URL_USER_LOG } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { FETCH_DATA_REQUEST, FETCH_DATA_ERROR, LOAD_LIST_USER_LOG } from '../actionTypes';

export const apiLoadListUserLog = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_USER_LOG}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_USER_LOG, response.data));
            })
            .catch(error => {
                console.log("error", error)
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};